module.exports = __webpack_public_path__ + "static/set-show-banner-category-97e91781e92bb907b47098d5b09ebf05.png";